import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "back-link__text" }

import { backLink } from '@/models/backlink'

export default /*@__PURE__*/_defineComponent({
  __name: 'BackLink',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(backLink).previousPage.fullPath,
    class: "back-link"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "back-link__icon iconfont iback" }, null, -1)),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(backLink).previousPageLabel), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})